
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admissions",
      function () {
        return require("private-next-pages/admissions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admissions"])
      });
    }
  